import {Component} from '@angular/core';

@Component({
  selector: 'app-link-my-patients',
  templateUrl: './link-my-patients.component.html',
  styleUrls: ['./link-my-patients.component.scss']
})
export class LinkMyPatientsComponent {
}
